enum BillingsTaxiUnbilledOrderListingViewMode {
  TAXI = "TAXI",
  RAILY = "RAILY",
}

export default BillingsTaxiUnbilledOrderListingViewMode;
